export const PATHS = {
  HOME: '/',
  ABOUT_PAGE: '/about',
  ABOUT_SECTION: '#about',
  HOTELS: {
    hotels: '/hotels',
    details: '/hotels/:id'
  },

  BLOG: {
    blog: '/blog',
    details: '/blog/:id'
  },
  CONTACTS: '/contacts',
  FAQ: '/faq',
  ERROR: '/404',
  LEGAL: '/:page'
};
